@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts?.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">
            {{ field.label | localize }}@if (field.required) {
            <span> *</span>
          }
        </mat-label>
      }
      <div class="flex flex-col w-full">
        @if (!field.compactMode) {
          <div class="flex flex-row justify-end">
            <mat-button-toggle-group [(ngModel)]="selectedLang">
              @for (lang of availableLangs; track lang) {
                <mat-button-toggle [value]="lang.id">
                  <mat-icon class="icon-size-5 mr-2" [color]="field.control.value[lang.id] ? 'primary' : ''"
                    [svgIcon]="field.control.value[lang.id] ? 'heroicons_solid:star' : 'heroicons_outline:star'">
                  </mat-icon>
                  @if (!field.useFlags) {
                    <span>{{ lang.label }}</span>
                  }
                  @if (field.useFlags) {
                    <span class="relative w-6 shadow rounded-sm overflow-hidden">
                      <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
                      <img class="w-full" [src]="'assets/images/flags/' + lang.id + '.svg'" [alt]="'Flag image for ' + lang.id">
                    </span>
                  }
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>
        }
                <mat-form-field class="flex-auto" [ngClass]="{
                        'fuse-mat-textarea': field.view === 'LANGUAGETEXTAREA',
                        'invalid': !field.readonly && field.control.status === 'INVALID' && field.control.touched,
                        '-mt-3': !field.compactMode
                    }">
          @if (!field.browserOpts?.inLineWithCaption) {
            <mat-label>{{ field.label | localize }}</mat-label>
          }
          @switch (field.view) {
            @case ('LANGUAGETEXT') {
                            <input matInput [formControl]="field.control | dTypeFormControl:selectedLang" [ngClass]="{
                                    'text-left': !field.browserOpts || field.browserOpts?.alignment === 'LEFT',
                                    'text-center': field.browserOpts?.alignment === 'CENTER',
                                    'text-right': field.browserOpts?.alignment === 'RIGHT',
                                    'uppercase': field.transform === 'UPPERCASE',
                                    'lowercase': field.transform === 'LOWERCASE'
                                }" [placeholder]="field.placeholder | localize" [readonly]="field.readonly"
                autocomplete="off" />
              }
              @case ('LANGUAGETEXTAREA') {
                            <textarea matInput [formControl]="field.control | dTypeFormControl:selectedLang" [ngClass]="{
                                    'text-left': !field.browserOpts || field.browserOpts?.alignment === 'LEFT',
                                    'text-center': field.browserOpts?.alignment === 'CENTER',
                                    'text-right': field.browserOpts?.alignment === 'RIGHT',
                                    'uppercase': field.transform === 'UPPERCASE',
                                    'lowercase': field.transform === 'LOWERCASE'
                                }" [placeholder]="field.placeholder | localize" [readonly]="field.readonly"
                autocomplete="off"></textarea>
              }
            }
            @if (field.compactMode) {
              <mat-select [(ngModel)]="selectedLang" matPrefix>
                @if (field.useFlags) {
                  <mat-select-trigger>
                    <span class="relative w-6 shadow rounded-sm overflow-hidden">
                      <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
                      <img class="w-full" [src]="'assets/images/flags/' + selectedLang + '.svg'" [alt]="'Flag image for ' + selectedLang">
                    </span>
                  </mat-select-trigger>
                }
                @for (lang of availableLangs; track lang) {
                  <mat-option [value]="lang.id">
                    @if (!field.useFlags) {
                      {{ lang.id }}
                    }
                    @if (field.useFlags) {
                      <span class="flex items-center">
                        <span class="relative w-6 shadow rounded-sm overflow-hidden">
                          <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
                          <img class="w-full" [src]="'assets/images/flags/' + lang.id + '.svg'" [alt]="'Flag image for ' + lang.id">
                        </span>
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
            }
            @if (!field.compactMode) {
              <mat-icon class="icon-size-5" matPrefix svgIcon="mat_outline:translate">
              </mat-icon>
            }
            <mat-hint>
              @if (!field.readonly &&
                field.control.touched &&
                field.control.hasError('required')) {
                <span class="text-warn">{{ 'errorLocaleTextRequired' | transloco }}</span>
              } @else {
                @if (field.hint) {
                  <span>{{ field.hint | localize }}</span>
                }
              }
            </mat-hint>
            @if (!field.readonly && field.control.touched && field.control.errors) {
              <mat-error>
                @if (field.control.hasError('minlength')) {
                  {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
                }
                @if (field.control.hasError('maxlength')) {
                  {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  }
} @else {
  {{ field.control.value | localize }}
}
